import { useDispatch, useSelector } from 'react-redux';
import { Color } from './tool/Color';
//import LogoTextList from "./LogoTextList";
import { useEffect, useRef, useState } from 'react';
import { useDeviceType } from '../hooks/useDeviceType';
import { useElementSize } from '../hooks/useElementSize';
import { LogoList } from './tool/LogoList';
import { Style } from './tool/Style';
import { useLogoFuncs } from '../hooks/responsive/useLogoFuncs';
import { setIsDisplay, setMessage } from '../redux-tool/slice/hintSlice';
import { setSelectedStyleID } from '../redux-tool/slice/toolSlice';
import './styles/Tool.css';
import { Color as ColorTablet } from './tool/tablet/Color';
import { LogoList as LogoListTablet } from './tool/tablet/LogoList';
import { Style as StyleTablet } from './tool/tablet/Style';
import { TextEditor } from './tool/TextEditor';
import { TextEditorTablet } from './tool/tablet/TextEditor';
import { useAutoApplyFirstStyle } from '../hooks/useAutoApplyFirstStyle';
import { Pattern } from './tool/Pattern';
import { PatternTablet } from './tool/tablet/Pattern';

export function Tool({
  logos,
  patterns,
  colors,
  customerId,
  styles,
  handleAddNewLogo,
  handleDeleteLogo,
  viewMode,
}) {
  const dispatch = useDispatch();
  const { activeTabBarId } = useSelector((state) => state.ui);
  const device = useDeviceType();
  const isMobile = device === 'mobile';
  const containerRef = useRef(null);
  const { width, height } = useElementSize(containerRef);
  const [styleIndex, setStyleIndex] = useState(0);
  const { activeIdx: activeLogoIndex, handleOnClick: handleActiveLogoIndex } = useLogoFuncs(logos);

  const handleStyleIndex = (activeTabBarId) => {
    setStyleIndex(activeTabBarId);
  };

  useEffect(() => {
    if (activeTabBarId === 0) {
      window.isSelectedLogoTool = true;
    }
    if (activeTabBarId === 1) {
      window.isSelectedLogoTool = true;
      window.isSelectingStyle = true;
    }
    if (activeTabBarId === 2) {
      window.isSelectedLogoTool = false;
      window.isSelectingStyle = true;
    }
    if (activeTabBarId === 4) {
      window.isSelectedLogoTool = true;
      window.isSelectingStyle = true;
    }

    switch (activeTabBarId) {
      case 0:
        dispatch(setIsDisplay(true));
        dispatch(setMessage('Select a logo, then click on the model to apply it.'));
        break;
      case 1:
        dispatch(setIsDisplay(true));
        dispatch(setMessage('Add and customize text on your design.'));
        break;
      case 2:
        dispatch(setIsDisplay(true));
        dispatch(setMessage('Select a style to apply to your product.'));
        break;
      case 3:
        dispatch(setIsDisplay(true));
        dispatch(setMessage('Select a color, then click on the model to apply it.'));
        break;
      case 4:
        dispatch(setIsDisplay(true));
        dispatch(setMessage('Select a pattern, then click on the model to apply it.'));
        break;
      default:
        dispatch(setIsDisplay(false));
    }
  }, [activeTabBarId, dispatch]);

  useEffect(() => {
    if (styles && Array.isArray(styles) && window.currentStyle?.Id) {
      const selectedStyleID = styles.findIndex((item) => item.Id === window.currentStyle.Id);
      if (selectedStyleID !== -1) {
        dispatch(setSelectedStyleID(String(selectedStyleID)));
      }
    }
  }, [dispatch, styles]);

  // Auto-apply first style when styles are loaded and object is ready
  useAutoApplyFirstStyle(styles);

  const innerContent = () => {
    switch (activeTabBarId) {
      case 0:
        return isMobile ? (
          <LogoList
            logos={logos}
            handleAddNewLogo={handleAddNewLogo}
            customerId={customerId}
            activeLogoIndex={activeLogoIndex}
            handleActiveLogoIndex={handleActiveLogoIndex}
            viewMode={viewMode}
            handleDeleteLogo={handleDeleteLogo}
          />
        ) : (
          <LogoListTablet
            logos={logos}
            handleAddNewLogo={handleAddNewLogo}
            customerId={customerId}
            activeLogoIndex={activeLogoIndex}
            handleActiveLogoIndex={handleActiveLogoIndex}
            viewMode={viewMode}
            handleDeleteLogo={handleDeleteLogo}
          />
        );
      case 1:
        return isMobile ? (
          <TextEditor customerId={customerId} />
        ) : (
          <TextEditorTablet customerId={customerId} />
        );
      case 2:
        return isMobile ? (
          <Style styles={styles} styleIndex={styleIndex} handleStyleIndex={handleStyleIndex} />
        ) : (
          <StyleTablet
            styles={styles}
            styleIndex={styleIndex}
            handleStyleIndex={handleStyleIndex}
          />
        );
      case 3:
        return isMobile ? (
          <Color colors={colors} pWidth={width} pHeight={height} />
        ) : (
          <ColorTablet colors={colors} pWidth={width} pHeight={height} />
        );
      case 4:
        return isMobile ? (
          <Pattern pattern={patterns} customer_id={customerId} viewMode={'customer'} />
        ) : (
          <PatternTablet
            pattern={patterns}
            customer_id={customerId}
            viewMode={'customer'}
          ></PatternTablet>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className={device === 'mobile' ? 'tool-space' : ''}></div>
      <div ref={containerRef} className={device === 'mobile' ? 'mobile-tool' : 'tablet-tool'}>
        {innerContent()}
      </div>
    </>
  );
}
